//全局状态

const state = {
  intoverDate: [],//存储驾驶舱筛选运力看板时间
  intoverListDate:[],//存储驾驶舱运单看板时间
  intoverMonDate:[],//存储驾驶舱财务看板时间
  intoverDeliverListDate:[],//存储驾驶舱货源看板时间
  mapList: [], //查询单个轨迹数据
  userInfo: {}, //用户信息
  menus: [], //菜单
  routes: [],//过滤后的菜单
  tabs: [],//打开的菜单
  cached: [],//缓存列表
  cachedViews: [], //需要keep-alive的页面组件的name列表
  isSetRoute: [], //已经显示的路由栈
  token: '',
  scrollEl:0, //鼠标滚动的事件参数
};

//getters
const getters = {

};

const mutations = {
  login(state, user) {
    state.userInfo = user
  },
  menu(state, menus) {
    state.menus = menus
  },
  initMenu(state, routes) {
    state.routes = routes
  },
  token(state, token) {
    state.token = token;
  },
  tabs(state, tabs) {
    tabs = tabs ? tabs : [];
    localStorage.setItem("tabs", JSON.stringify(tabs));
    state.tabs = tabs;
  },
  cached(state, cached) {
    state.cached = cached;
  },
  cachedViews(state, cachedViews) {
    state.cachedViews = cachedViews
  },
  isSetRoute(state, isSetRoute) {
    state.isSetRoute = isSetRoute;
  },
  mapList(state, mapList) {
    // console.log(state, mapList);
    state.mapList = mapList;
  },
  compId(state,compId) {
      state.compId = compId;
  },
  setIntoverDate(state, date) {
    state.intoverDate = date
  },
  setIntoverListDate(state, date) {
    state.intoverListDate = date
  },
  setIntoverMonDate(state, date) {
    state.intoverMonDate = date
  },
  setIntoverDeliverListDate(state, date){
    state.intoverDeliverListDate = date
  },

};
// actions
const actions = {

};

export default {
  // namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/sharing.js